import {Dispatch} from "react";
import {ColumnSort} from "@tanstack/react-table";

export type SortDirection = "desc" | "asc";
type ColumnId = string;

export interface IDataTableState {
    sortByRule: {
        sortByColumnId: ColumnId;
        sortDirection: SortDirection;
    } | null;
    pagination: {
        page: number;
    };
}

export const dataTableInitialState: IDataTableState = {
    sortByRule: null,
    pagination: {
        page: 1
    }
};

export enum ActionTypes {
    CHANGE_SORT,
    CHANGE_PAGE
}

export const dataTableActions = {
    changeSortBy: (
        sortByRule: ColumnSort | null
    ): {
        type: ActionTypes.CHANGE_SORT;
        sortByRule: IDataTableState["sortByRule"];
    } => ({
        type: ActionTypes.CHANGE_SORT,
        sortByRule: sortByRule
            ? {
                  sortByColumnId: sortByRule.id,
                  sortDirection: sortByRule.desc ? "desc" : "asc"
              }
            : null
    }),
    changePage: (
        page: IDataTableState["pagination"]["page"]
    ): {
        type: ActionTypes.CHANGE_PAGE;
        page: IDataTableState["pagination"]["page"];
    } => ({
        type: ActionTypes.CHANGE_PAGE,
        page
    })
};

type DataTableActionType = ReturnType<typeof dataTableActions.changeSortBy | typeof dataTableActions.changePage>;
export type DataTableDispatchType = Dispatch<DataTableActionType>;

export const dataTableReducer = (state: IDataTableState, action: DataTableActionType): IDataTableState => {
    switch (action.type) {
        case ActionTypes.CHANGE_SORT:
            return {
                ...state,
                sortByRule: action.sortByRule
            };
        case ActionTypes.CHANGE_PAGE:
            return {
                ...state,
                pagination: {
                    page: action.page
                }
            };
        default:
            return state;
    }
};
import {Dispatch} from "react";
import {ColumnSort} from "@tanstack/react-table";

export type SortDirection = "desc" | "asc";
type ColumnId = string;

export interface IDataTableState {
    sortByRule: {
        sortByColumnId: ColumnId;
        sortDirection: SortDirection;
    } | null;
    pagination: {
        page: number;
    };
}

export const dataTableInitialState: IDataTableState = {
    sortByRule: null,
    pagination: {
        page: 1
    }
};

export enum ActionTypes {
    CHANGE_SORT,
    CHANGE_PAGE
}

export const dataTableActions = {
    changeSortBy: (
        sortByRule: ColumnSort | null
    ): {
        type: ActionTypes.CHANGE_SORT;
        sortByRule: IDataTableState["sortByRule"];
    } => ({
        type: ActionTypes.CHANGE_SORT,
        sortByRule: sortByRule
            ? {
                  sortByColumnId: sortByRule.id,
                  sortDirection: sortByRule.desc ? "desc" : "asc"
              }
            : null
    }),
    changePage: (
        page: IDataTableState["pagination"]["page"]
    ): {
        type: ActionTypes.CHANGE_PAGE;
        page: IDataTableState["pagination"]["page"];
    } => ({
        type: ActionTypes.CHANGE_PAGE,
        page
    })
};

type DataTableActionType = ReturnType<typeof dataTableActions.changeSortBy | typeof dataTableActions.changePage>;
export type DataTableDispatchType = Dispatch<DataTableActionType>;

export const dataTableReducer = (state: IDataTableState, action: DataTableActionType): IDataTableState => {
    switch (action.type) {
        case ActionTypes.CHANGE_SORT:
            return {
                ...state,
                sortByRule: action.sortByRule
            };
        case ActionTypes.CHANGE_PAGE:
            return {
                ...state,
                pagination: {
                    page: action.page
                }
            };
        default:
            return state;
    }
};
